<div class="media-loader" *ngIf="isMediaLoading">
  <mat-spinner diameter="50"></mat-spinner>
  <p>Loading {{ isVideo ? 'video' : 'audio' }}...</p>
</div>

<div *ngIf="mediaType === 'video'" class="video-container">
  <video
    #mediaPlayer
    class="secure-media secure-video"
    [src]="mediaUrl"
    [muted]="isMuted"
    autoplay
    playsinline
    controlsList="nodownload noplaybackrate noremoteplayback"
    disablePictureInPicture
    disableRemotePlayback
    (loadedmetadata)="onMediaMetadata()"
    (canplay)="onMediaReady()"
    (timeupdate)="onMediaTimeUpdate()"
    (seeking)="onMediaSeeking()"
    (play)="isMediaPlaying = true"
    (pause)="isMediaPlaying = false"
    (ended)="isMediaPlaying = false"
    (click)="toggleMediaPlay()"
    (error)="onMediaError()"
  ></video>
  <ng-container *ngTemplateOutlet="mediaControls; context: { $implicit: true }"></ng-container>
</div>

<div *ngIf="mediaType === 'audio'" class="audio-container">
  <div class="audio-artwork">
    <mat-icon>audiotrack</mat-icon>
  </div>
  <div class="audio-player-wrap">
    <audio
      #mediaPlayer
      class="secure-audio"
      [src]="audioSrc"
      [muted]="isMuted"
      autoplay
      (loadedmetadata)="onMediaMetadata()"
      (canplay)="onMediaReady()"
      (timeupdate)="onMediaTimeUpdate()"
      (seeking)="onMediaSeeking()"
      (play)="isMediaPlaying = true"
      (pause)="isMediaPlaying = false"
      (ended)="isMediaPlaying = false"
      (error)="onMediaError()"
    ></audio>
    <ng-container *ngTemplateOutlet="mediaControls; context: { $implicit: false }"></ng-container>
  </div>
</div>

<ng-template #mediaControls let-isVideoControls>
  <div class="audio-controls" [class.video-controls]="isVideoControls">
    <button mat-icon-button class="audio-play-btn" (click)="toggleMediaPlay()" [title]="isMediaPlaying ? 'Pause' : 'Play'">
      <mat-icon>{{ isMediaPlaying ? 'pause' : 'play_arrow' }}</mat-icon>
    </button>
    <span class="audio-time">{{ formatTime(currentTimeSec) }}</span>
    <div class="video-progress-track audio-progress-track">
      <span class="video-progress-played" [style.width.%]="progress"></span>
      <span
        *ngIf="segmentWidthPercent > 0"
        class="video-progress-segment"
        [style.left.%]="segmentStartPercent"
        [style.width.%]="segmentWidthPercent"
      >
        <span class="video-progress-segment-played" [style.width.%]="segmentProgressPercent"></span>
      </span>
      <span *ngIf="segmentWidthPercent > 0" class="video-progress-time video-progress-start" [style.left.%]="segmentStartPercent">
        {{ formatTime(startTime) }}
      </span>
      <span *ngIf="segmentWidthPercent > 0" class="video-progress-time video-progress-end" [style.left.%]="segmentEndPercent">
        {{ formatTime(endTime) }}
      </span>
      <input
        type="range"
        class="progress-range"
        min="0"
        [max]="duration || 0"
        step="0.1"
        [value]="currentTimeSec"
        [attr.aria-label]="isVideoControls ? 'Video progress' : 'Audio progress'"
        (input)="onSeekInput($event)"
      />
    </div>
    <span class="audio-time audio-time-total">{{ formatTime(duration) }}</span>
    <button mat-icon-button class="audio-play-btn" (click)="toggleMute()" [title]="isMuted ? 'Unmute' : 'Mute'">
      <mat-icon>{{ isMuted ? 'volume_off' : 'volume_up' }}</mat-icon>
    </button>
  </div>
</ng-template>
